import FullWidthLayout from "@/layouts/FullWidthLayout";
import { KPageIndex } from "kinnect-general";
import { Pageable } from "kinnect-mixins";

export default {
	name: "SafetyPage",

	metaInfo: { title: "Safety" },

	mixins: [ Pageable ],

	data: () => ( {
		items: [
			{
				title: "Near Miss Reports",
				to: { name: "safetyNearMisses" }
			},
			{
				title: "Employee Injury Reports",
				to: { name: "safetyEmployeeInjuries" }
			}

			// {
			// 	title: "Accident / Incident Reports",
			// 	to: { name: "safetyAccidents" }
			// },
		]
	} ),

	render() {
		return <FullWidthLayout>
			<KPageIndex items={this.items}></KPageIndex>
		</FullWidthLayout>;
	}
};
